import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import CalendarContextMenu from './CalendarContextMenu';

export default class MoeOverviewManager {
  constructor() {
    this.calendar = null;
    this.$container = $('#moe-overview-calendar-container');
    this.$modal = $('#moeOverviewModal');

    if (!this.$container.length || !this.$modal.length) {
      return;
    }

    this.calendarUrl = this.$container.data('calendar-url');
    this.taskId = this.$container.data('task-id');

    this.contextMenu = new CalendarContextMenu();
    this.bindModalEvents();
  }

  initCalendar() {
    const calendarEl = document.getElementById('moe-overview-calendar');
    if (!calendarEl) { return; }

    this.calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
      initialView: 'dayGridMonth',
      locale: 'fr',
      timeZone: 'Europe/Paris',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      buttonText: {
        today: "Aujourd'hui",
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour'
      },
      slotMinTime: '07:00:00',
      slotMaxTime: '20:00:00',
      allDaySlot: false,
      selectable: false,
      editable: false,
      height: 'auto',

      events: (info, successCallback, failureCallback) => {
        $.ajax({
          url: this.calendarUrl,
          method: 'GET',
          data: { task_id: this.taskId, start: info.startStr, end: info.endStr },
          headers: { 'Accept': 'application/json' },
          success: (data) => { successCallback(data); },
          error: (xhr) => {
            console.error('Failed to fetch MOE overview calendar events:', xhr.responseText);
            failureCallback(xhr);
          }
        });
      },

      eventDidMount: this.contextMenu.getEventDidMount((_actionExecutionId, _message) => {
        this.calendar.refetchEvents();
      })
    });

    this.calendar.render();
  }

  bindModalEvents() {
    this.$modal.off('shown.bs.modal.moeOverview').on('shown.bs.modal.moeOverview', () => {
      if (!this.calendar) {
        this.initCalendar();
      } else {
        this.calendar.updateSize();
        this.calendar.refetchEvents();
      }
    });
  }

  destroy() {
    if (this.$modal && this.$modal.length) {
      this.$modal.off('shown.bs.modal.moeOverview');
    }
    if (this.calendar) {
      this.calendar.destroy();
      this.calendar = null;
    }
  }
}
